export const TOKEN_TYPE = "Bearer ";
export const REQUEST_HEADER_AUTH_KEY = "Authorization";
export const SML_AUTH_HEADER_KEY = "Basic c21saWNybTpTbWxpQENSTTI0";
export const BUCKET_URL = "https://vahan-pro.s3.ap-south-1.amazonaws.com/";

export const USERS = { ADMIN: "admin", VENDOR: "vendor" };
export const APIS = {
  AUTH: {
    LOGIN: "/admin/login",
    VENDOR_LOGIN: "/vendor/login",
  },

  VENDORS: {
    ADDEDIT_VENDOR: "/admin/addEditVendor",
  },

  VENDORS_LINK: {
    USERS: "/admin/listUsers",
    ADDEDIT_USERS: "/admin/registerUser",
  },

  ADMIN_BLOCKDELETEDATA: "/admin/blockDeleteData",

  ADMIN_LINK: {
    LISTDATA: "/admin/listData",
    ADDEDIT_ADMINS: "/admin/addEditAdmins",
  },

  DESTINATION_AND_QUOTA: {
    LISTING: "/admin/listDesignations",
    ADDEDIT_DESTINATION_AND_QUOTA: "/admin/addEditDesignation",
  },
  BULK_UPLOAD : "/admin/bulkUpload",
  BULK_UPLOAD_LOGS : "/admin/bulkLogs",
  EXPORT_DATA : "/admin/exportData",
  ADMIN: {
    CREATE_ADMIN: "/admin/create",
    DELETE_ADMIN: "/admin/delete",
    EDIT_ADMIN: "/admin/editAdmin",
  },
 
  ADMIN_LIST: "/admin/getAdmin",
  LIST_VENDORS: "/admin/listData",

  
  VENDOR_DASHBOARD: "/admin/dashboard",

  CHANGE_PASSWORD: "/crmapi/api/UserLogin/UserChangePassword",

  // Vehicle Management
  VEHICLE_MANAGEMENT: {
    SEARCH: "/admin/ulipSearch",
    DETAILS: "/admin/details",
    CHALLANS: "/admin/ulipChallanSearch",
    FASTAG_JOURNEY: "/admin/ulipFastagSearch",
  },

  // App settings
  APP_SETTINGS: "/admin/appSettings",
  UPDATE_ULIP_API_TYPE: "/admin/updateUlipApiType",
};
